import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconBoldStyle0 = gravityIconIndividualCss;

const GravityIconBold = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'b2eec28a303e8b5bafa77090c33ef193e92ed1f2', color: this.color, size: this.size }, h("svg", { key: 'b4c545d1fae240309229c58152fc110e7a43b037', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'ef3c9d075697b4d20462c3d3b20aaed6f2444b2e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16 14.13c0 2.39-1.69 3.87-4.37 3.87H6.5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5h4.65c2.66 0 4.26 1.37 4.26 3.66a3.51 3.51 0 0 1-1.33 3A3.51 3.51 0 0 1 16 14.13ZM9 6.56v3h1.8c1.11 0 1.75-.45 1.75-1.47s-.58-1.48-1.71-1.48L9 6.56Zm2.12 8.88c1.27 0 2-.56 2-1.73s-.75-1.65-2-1.65H9v3.38h2.12Z", fill: "currentColor" }))));
    }
};
GravityIconBold.style = GravityIconBoldStyle0;

export { GravityIconBold as gravity_icon_bold };

//# sourceMappingURL=gravity-icon-bold.entry.js.map